// extracted by mini-css-extract-plugin
export var barContainer = "_28-0";
export var extraThin = "_28-3";
export var fillBar = "_28-6";
export var fillContainer = "_28-4";
export var overflow = "_28-8";
export var overflowContainer = "_28-5";
export var regular = "_28-7";
export var thick = "_28-1";
export var thin = "_28-2";